import { useBlocker } from 'react-router-dom';
import { useEffect, useRef } from 'react';

export function usePrompt(when, onLeaveAttempt) {
  const blocker = useBlocker(when);
  const callbackRef = useRef(onLeaveAttempt);

  // Keep callback ref updated
  useEffect(() => {
    callbackRef.current = onLeaveAttempt;
  }, [onLeaveAttempt]);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      // Call the callback with proceed and reset functions
      // The callback should handle showing the modal and storing the location
      callbackRef.current(
        () => {
          blocker.proceed();
        },
        () => {
          blocker.reset();
        },
        blocker.location,
      );
    }
  }, [blocker.state, blocker]);
}
